/* ==========================================================
   Scrolling offer bar (sections/ns-ticker-bar.liquid)
   Pause / play button. Listens on document, so it keeps working
   after the theme editor reloads the section.
   ========================================================== */

document.addEventListener("click", function (e) {
  var button = e.target.closest && e.target.closest(".ns-ticker__toggle");
  if (!button) return;

  var paused = button.closest(".ns-ticker").classList.toggle("is-paused");

  button.setAttribute("aria-label", paused ? "Play" : "Pause");
  button.setAttribute("aria-pressed", paused ? "true" : "false");
});
